// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearchEnergy2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.24 7.31a6.24 6.24 0 1 1-12.481-.008 6.24 6.24 0 0 1 12.48.008z"
    />
    <path
      fill="currentColor"
      d="m14.324 7.241-3.137 4.073c-.12.196-.195.179-.16-.037l.417-3.374H9.84c-.21 0-.285-.148-.161-.343l3.133-4.073c.12-.196.196-.175.162.041l-.419 3.37h1.605c.209-.003.284.158.164.343z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.278 23.01h-2.811v-7.088h2.811zM12 13.546v2.376"
    />
  </svg>
);
export default SvgSearchEnergy2;
